import { COLORS } from '@btime/constants'
import { identity } from 'ramda'
import React from 'react'

import { SmallText, Text } from '../../components/presentation/Text'
import { useIsPermalinkPage } from '../../utils/session/permalinkToken'
import { useOpenAssetModal } from '../../utils/routes/modals/modalsActions'
import FlexGrid from '../../components/structure/FlexGrid'
import Icon from '../../components/shapes/Icon'
import Link from '../../components/actions/Link'

const getResumeSize = size => {
  switch (size) {
    case 'small':
      return 'xsmall'
    case 'xsmall':
      return 'xxsmall'
    default:
      return 'small'
  }
}

const AssetPresenter = ({ asset, place, size, hideIcon, fontSize, ...props }) => {
  const openModal = useOpenAssetModal()
  const isPublic = useIsPermalinkPage()
  if (!asset) return false

  const resumeSize = getResumeSize(fontSize || size)
  const subtitle = [asset.place?.name || place?.name, asset.type?.name].filter(identity).join(' | ')

  return (
    <Link block onClick={!isPublic ? () => openModal(asset) : undefined} underlineOnHover>
      <FlexGrid justify="flex-start" gutter={0.15}>
        <Text size={fontSize || size} {...props}>
          {asset.name}
        </Text>
        {!hideIcon && !isPublic && <Icon name="BsSearch" color={COLORS.dark3} size="0.8rem" />}
      </FlexGrid>
      <SmallText {...props} size={resumeSize} color={COLORS.dark3}>
        {subtitle}
      </SmallText>
    </Link>
  )
}

export default AssetPresenter
